class Storage {
  constructor(options = {}) {
    this.prefix = options.prefix || 'middlePlatform';
  }
  get(key, type = 'local') {
    return [`${type}Storage`].getItem(key);
  }
  set(key, value, type = 'local') {
    return [`${type}Storage`].setItem(key, value);
  }
}

export class GeneralKeyValueStorage {
  constructor(storageKey = 'generalKeyValueArray', maxLength = 10) {
    this.STORAGE_KEY = storageKey;
    this.maxLength = maxLength;
  }

  getStoredArray() {
    const storedData = localStorage.getItem(this.STORAGE_KEY);
    return storedData ? JSON.parse(storedData) : [];
  }

  setValueByKey(key, value) {
    let array = this.getStoredArray();
    const existingIndex = array.findIndex(item => item.key === key);
    if (existingIndex !== -1) {
      array[existingIndex].value = value;
    } else {
      if (array.length >= this.maxLength) {
        array.shift();
      }
      array.push({ key, value });
    }
    localStorage.setItem(this.STORAGE_KEY, JSON.stringify(array));
  }

  getValueByKey(key) {
    const array = this.getStoredArray();
    const item = array.find(item => item.key === key);
    return item ? item.value : null;
  }
  deleteKeyValue(key) {
    let array = this.getStoredArray();
    const newArray = array.filter(item => item.key !== key);
    localStorage.setItem(this.STORAGE_KEY, JSON.stringify(newArray));
  }
}
export default new Storage();
